import { Component, inject } from '@angular/core';
import { AppConfig } from '../../../appconfig';

@Component({
    selector: 'ldw-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.css'],
    standalone: false
})
export class LogoComponent {
  private config = inject(AppConfig);

  constructor() {}
  get longVersion() {
    return 'Version ' + this.config.version();
  }
  get shortVersion() {
    return 'V' + this.config.version();
  }
}
